









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "../index.vue";
import { Button } from "mint-ui";
import { goUrl } from "@/utils/hybird"
import qrcode from '@/components/qrcode.vue'

@Component<VBANNER>({
  components: {
    dialogComp,
    qrcode,
    "mt-button": Button,
  },
})
export default class VBANNER extends Vue {
  public identifyCode:string = '';
  public isExist:boolean = false;
  public show() {
    (this.$refs.dialog as any).show();
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  public goUrl(url:any,linkId:any){
        goUrl(url,linkId)
  }
  public mounted(){
      
  }
}
